import React, { Component }        from "react";
import { Button, PageHeader, Form, FormGroup, InputGroup, FormControl, ListGroup, Row, Col } from "react-bootstrap";
import uniqueId                    from 'lodash/uniqueId';
import TextAreaMod                 from "../../components/TextAreaMod";
import LoaderButton                from "../../components/LoaderButton";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import RenderLander                from "../../components/utils/RenderLander";
import { Colors }                  from "../../utils/Colors";
//import { EditorState, convertToRaw, ContentState } from 'draft-js';
//import { Editor }                  from 'react-draft-wysiwyg';
//import draftToHtml                 from 'draftjs-to-html';
import YouTubePlayer               from "../../components/YouTubePlayer";
//import HelpEditor                  from "../../components/help/HelpEditor"; //HelpEditor
import { invokeGetHelpFAQ, invokeSetAddHelpFAQ } from "../../utils/AwsInvoke";
import "../../css/help/HelpList.css";

export default class HelpNew extends Component {
    constructor(props) {
        super(props);

        //var search_term = `${this.props.match.params.search_term}`;
        //if(search_term === "&") search_term = "";
        // temp
        var search_term = "";
        this.state = {
            helpUID: `${this.props.match.params.help_id}`,
            isLoading: false,
            question: "",
            title: "",
            ytId: "",
            showLoadingBar:"none"
        };
    }

    componentDidMount() {
        if(this.state.helpUID != "&")
            this.getHelpFAQ();
    }

    clearSearchField = () => {
        // RESET URL
        //this.props.history.replace("/help/admin/&")

        this.setState({
            searchTerm: "", // reset search term if resetting member list
        })
    }

    handleAnswerChange = (event) => {
        this.setState({ answer: event.target.value});
    }

    handleQuestionChange = (event) => {
        this.setState({ question: event.target.value});
    }

    cancelHelpFAQ () {
        this.props.history.goBack();
    }

    getHelpFAQ = async () => {
        var uid = this.state.helpUID;
        var result = await invokeGetHelpFAQ(uid);

        if(result) {
            var help_id    = result[0].uid;
            var youtube_id = result[0].youtube_id;
            var question   = result[0].question;
            var answer     = result[0].answer;
            //var content        = data.content;

            this.setState({
                helpId:     help_id,
                ytId:       youtube_id,
                question:   question,
                answer: answer
                //answerEditorContent: answer
            })
        }
    }

    handleSubmit = async () => {
        var help_id    = this.state.helpId;
        var question   = this.state.question;
        var answer     = this.state.answer; //answerEditorContent;
        var youtube_id = this.state.ytId

        var contentBlock;

        ////  If there are any empty message bodies it will cause an error when calling message_body.getCurrentContent(); ////
        /*if(answer != "")
            contentBlock = draftToHtml(answer);
        else contentBlock = "";
        console.log("contentBlock: " + contentBlock);*/

        var result = await invokeSetAddHelpFAQ(help_id, youtube_id, question, answer);

        if(result) {
            this.props.history.push("/help/admin/&");
            /*this.setState({
                isLoading: false,
                showLoadingBar: "none",
                showDeleteConfirmWin: false
            });*/
        } else
            alert("Ooops, there was an error adding your Help FAQ.")

    }

    handleVideoLinkChange  = (event) => {
        var text = event.target.value;
        var newval = '';

        if (newval = text.match(/(\?|&)v=([^&#]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\.be\/)+([^\/]+)/)) {
            text = newval.pop();
        } else if (newval = text.match(/(\embed\/)+([^\/]+)/)) {
            text = newval.pop().replace('?rel=0','');
        }

        this.setState({
            ytId: text
        });
    }

    /*answerEditorContent = (content) => {

        this.setState({
            answerEditorContent: content
        });
    }*/

    renderHelpList() {
        //var youTubeId = "ce_0XT1BBQA";

        return  (
                <div className="exerciseHeaderSearchBar-old">
                     <div style={{display:"inline-block", width:"100%", border:"0px solid #000"}}>
                        { /*}<form onSubmit={this.handleSubmit} className="form"> */}
                                   <div className="helpMainBod">
                                       { /*}<div className="helpYouTubeContainer">
                                           <YouTubePlayer yt_id={youTubeId}
                                       </div>/>*/ }
                                       <div className="formLabel">
                                           YouTube Video Link
                                       </div>
                                       <div style={{textDecoration: "none"}}>
                                               <input type="text"
                                                      placeholder = "YouTube Link"
                                                      value       = {this.state.ytId}
                                                      onChange    = {this.handleVideoLinkChange.bind(this)}
                                                      className   = "input-lg tf_addExercise" />

                                       </div>
                                   </div>

                                   <div className="iconAddExercise25pxVertSpacer"></div>

                                   { /********************** TITLE *********************/ }
                                             <span className="formLabel">
                                                 Question
                                             </span>
                                             <span>
                                             <textarea className    = "helpNewAnswer_tf"
                                                       placeholder  = {""}
                                                       value        = {this.state.question}
                                                       onChange     = {this.handleQuestionChange}
                                                    />
                                             </span>

                                   { /********************** answer *********************/ }
                                   <div className="iconAddExercise25pxVertSpacer"></div>
                                             <span className="formLabel">
                                                   Answer
                                             </span>
                                             <span style={{textDecoration: "none"}}>

                                                 <textarea placeholder  = {""}
                                                           className    = "helpNewQuestion_tf"
                                                           value        = {this.state.answer}
                                                           onChange     = {this.handleAnswerChange}
                                                        />
                                                   { /*}<HelpEditor raw_content={this.state.answerEditorContent}
                                                               setExistingEditorImages={"not-applicable"}
                                                               assessmentEditorContent={this.answerEditorContent}/> */ }
                                                   { /*}<Editor
                                                       editorState         = {this.state.answerEditorContent}
                                                       onEditorStateChange = {this.answerEditorContent}
                                                       toolbarHidden       = { false }
                                                       readOnly            = { false }
                                                       editorStyle         = {{lineHeight: '100%'}}
                                                       toolbar = {{
                                                             inline:    {
                                                                 inDropdown: false,
                                                                 options: ['bold', 'italic', 'underline', /*'strikethrough', 'monospace'* /]
                                                             },
                                                             list:      { inDropdown: false },
                                                             textAlign: { inDropdown: false },
                                                             link:      { inDropdown: true },
                                                             history:   { inDropdown: false },
                                                             options:[/*'inline','colorPicker', * /'emoji', 'link' ]
                                                       }}
                                                   />*/ }
                                             </span>
                                             <br/><br/>
                                   <div className="iconAddExerciseVertSpacer"></div>

                                               { /********************** SUBMIT BUTTON *********************/ }
                                               <Row className="grid">
                                                     <Col xs={6} sm={6} md={6}>
                                                             <span onClick = { () => this.cancelHelpFAQ()}>
                                                                 <LoaderButton
                                                                   block
                                                                   type    = "button"
                                                                   text    = "Cancel"
                                                                   style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                                                 />
                                                             </span>
                                                       </Col>
                                                       <Col xs={6} sm={6} md={6}>
                                                            <span onClick = { () => this.handleSubmit()}>
                                                                 <LoaderButton
                                                                     block
                                                                     style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                                                     //disabled={!this.validateForm()}
                                                                     isLoading={this.state.isLoading}
                                                                     text    = "Submit"
                                                                     type    = "submit"
                                                                     loadingText="Saving …"
                                                                 />
                                                            </span>
                                                       </Col>
                                                   </Row>

                               <br/><br/>
                      </div>
                </div>
                )
    }

    renderHelp() {
        return (
          <div className="programs">
            <PageHeader>
                    Help - Add New Section
            </PageHeader>
            <br/>

              <span style={{display: "inline-block", width:"100%"}}>
                  {!this.state.isLoading && this.renderHelpList()}
              </span>
          </div>
        );
    }

    render() {
        return (
              <div className="Home">
                { /* /* temp remove 6-28-2018 while flying
                    this.props.isAuthenticated ? this.renderHelp() : <RenderLander />
                    */}
                { this.renderHelp() }

                <FooterLoadingBar text={"Retieving Members ..."}
                                  showLoadingBar={this.state.showLoadingBar}
                />
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/help/HelpNew.js